import { useWeb3Modal } from "@web3modal/wagmi/react";
import { StyledButton } from "./AppComponents";
import { useContext } from "react";
import { AppContext } from "../../utils";

export const ExampleButton = () => {
  const { account } = useContext(AppContext);
  const { open } = useWeb3Modal();

  return (
    <StyledButton
      width={{ md: "210px", xs: "170px" }}
      style={{ height: "43px", fontWeight: "500" }}
      onClick={async () => await open()}
    >
      {account
        ? account.slice(0, 4) + "..." + account.slice(-4)
        : "Connect Wallet"}
    </StyledButton>
  );
};
